import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {ExportConfigDto} from "../../../../models/config/export/ExportConfigDto";
import {AntragConfigDto} from "../../../../models/config/antrag/AntragConfigDto";

@Injectable({
  providedIn: 'root'
})
export class GeneralConfigService {

  headers: HttpHeaders;

  baseUrl = 'api/config/general';


  constructor(private readonly http: HttpClient) { }

  getExportConfig(): Observable<ExportConfigDto> {
    this.setAuthToken();
    return this.http.get<ExportConfigDto>(this.baseUrl + "/export", {headers: this.headers});
  }

  getAntragConfig(): Observable<AntragConfigDto>{
    this.setAuthToken();
    return this.http.get<AntragConfigDto>(this.baseUrl + "/antrag", {headers: this.headers});
  }

  private setAuthToken() {
    let authToken: string = sessionStorage.getItem('authToken');
    this.headers = new HttpHeaders({
      'Authorization': 'Bearer ' + authToken
    });
  }
}
